import React, { useState, useEffect } from "react";
import "../../styles/Video.scss";
import videoFile from "../../components/assets/video/aplic-video.mp4";

const Video: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  return (
    <section className="video-section">
      <div className="video-wrapper" onClick={() => setShowModal(true)}>
        <video
          className="bg-video"
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
        ></video>

        <div className="video-overlay"></div>

        <div className="video-text">
          <div className="text-block">
            The Asia Pacific Life Insurance Congress (APLIC) is the region's
            premier gathering of the Insurance professional leaders, and
            visionaries. Hold every two years, the Congress brings together the
            thousand of delegates from member associations under the Asia
            Pacific Financial Services Association (APFinSA).
          </div>

          <div className="text-block">
            APLIC 2027 aims to empower agents and leaders to rise above
            challenges, embrace innovation, and create meaningful impact across
            communities throughout the Asia Pacific region.
          </div>
        </div>
      </div>


      {showModal && (
        <div className="video-modal">
          <div className="modal-overlay" onClick={() => setShowModal(false)} />

          <div className="modal-content">
            <button
              className="close-btn"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>

            <video src={videoFile} controls autoPlay />
          </div>
        </div>
      )}
    </section>
  );
};

export default Video;
